import {
    IEventInformationData,
    IItinerarymap,
    tryParseJSON,
} from '@eventr/common'
import { VerticalExpander } from '@eventr/common-storybook'
import { Box } from '@mui/material'
import { FC, useMemo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useScrollContext } from '../../../state/scrollState/scrollContext'
import { windowSizes } from '../../../state/windowState/windowSignals'
import { CarouselSlideBackground } from './CarouselSlideBackground'
import { ItineraryDateWindow } from './ItineraryDateWindow'
import { ItineraryTitle } from './ItineraryTitle'
import { OrganisationTag } from './OrganisationTag'

type TCarouselSlide = {
    id?: string
    slidesInView: number[]
    index: number
    itineraryMap: IItinerarymap
}

export const CarouselSlide: FC<TCarouselSlide> = ({
    slidesInView,
    index,
    itineraryMap,
}) => {
    const { headerHeight } = useScrollContext(
        useShallow((s) => ({ headerHeight: s.headerHeight }))
    )
    const itineraryInformation: IEventInformationData = useMemo(() => {
        if (!itineraryMap || !itineraryMap.value) return undefined

        try {
            if (typeof itineraryMap.value === 'string') {
                return tryParseJSON(itineraryMap.value, {
                    OSMAddress: {},
                    title: 'EventR',
                    start_date: '',
                    end_date: '',
                    cover_image: '',
                    website: '',
                    additionFiles: [],
                })
            }
            return itineraryMap.value
        } catch {
            console.log('error parsing value', itineraryMap.value)
            return undefined
        }
    }, [itineraryMap])

    return (
        <div
            style={{
                flex: '0 0 100%',
                minWidth: '0',
                height: '100%',
            }}
        >
            <CarouselSlideBackground
                src={
                    slidesInView.includes(index)
                        ? itineraryInformation?.cover_image
                        : undefined
                }
            >
                <Box
                    display={'grid'}
                    padding={`${windowSizes.value.insets?.insets.top}px 8px 0px 8px`}
                    height={'100%'}
                    maxHeight={
                        headerHeight === 156
                            ? headerHeight - 60
                            : headerHeight - 32
                    }
                >
                    <Box
                        display={'grid'}
                        gridTemplateRows={'auto 1fr auto'}
                        height={'100%'}
                        alignItems={'center'}
                        justifyItems={'center'}
                        padding={'8px 0 0 0'}
                    >
                        <Box
                            sx={{
                                transition: 'opacity 0.5s',
                                opacity: headerHeight === 156 ? '1' : 0,
                                pointerEvents:
                                    headerHeight === 156 ? 'auto' : 'none',
                            }}
                        >
                            <VerticalExpander
                                open={headerHeight === 156}
                                transition="0.5s ease"
                            >
                                <OrganisationTag />
                            </VerticalExpander>
                        </Box>
                        <ItineraryTitle
                            id="carouselslide-"
                            name={itineraryInformation?.title || ''}
                        />
                        <Box
                            sx={{
                                transition: 'opacity 0.5s',
                                opacity: headerHeight === 156 ? '1' : 0,
                            }}
                        >
                            <VerticalExpander
                                // open={headerHeight === 156}
                                open
                                transition="0.5s ease"
                            >
                                <ItineraryDateWindow
                                    id="carouselslide-"
                                    start={itineraryInformation?.start_date}
                                    end={itineraryInformation?.end_date}
                                    tags={itineraryMap?.tags}
                                />
                            </VerticalExpander>
                        </Box>
                    </Box>
                </Box>
            </CarouselSlideBackground>
        </div>
    )
}
